const PeopleCard = (props) => {
  const { link, name, firstname, lastname, role, image } = props

  const PeopleCardContent = (
    <>
      {image &&
      <div className="PeopleCard-aside">
        <div className="PeopleCard-figure">
          <img className="PeopleCard-image" src={image[0].url} alt={name} />
        </div>
      </div>
      }
      <div className="PeopleCard-main">
        <div className="PeopleCard-content">
          {name &&
            <div className="PeopleCard-name">
              <span>{ firstname }</span>
              <span>{ lastname }</span>
            </div>
          }
          {role &&
            <div className="PeopleCard-label">
              <span className="PeopleCard-labelText">{ role }</span>
              {link.url &&
              <svg className="PeopleCard-labelArrow">
                <use xlinkHref="#icon-arrow-right"/>
              </svg>
              }
            </div>
          }
        </div>
      </div>
    </>
  )

  return (link.url) ? (
    <a className="PeopleCard PeopleCard--link" href={link.url} target={`_blank`} rel={`${link.type === 'email' ? '' : 'noopeneer nofollow'}`}>
      {PeopleCardContent}
    </a>
  ) : (
    <div className="PeopleCard">
      {PeopleCardContent}
    </div>
  )
}

export default PeopleCard
